import React from 'react';
import { Link } from 'react-router-dom';

const MobileMarketing = () => (
  <section className="min-h-screen bg-[#0f1a29] py-20 px-4 flex flex-col items-center justify-center">
    <div className="max-w-3xl w-full bg-white rounded-2xl shadow-2xl p-10 relative z-10">
      <h1 className="text-4xl font-bold text-brand-blue mb-6 text-center">Mobile Marketing</h1>
      <p className="text-lg text-gray-700 mb-6 text-center">
        Reach your customers wherever they are with targeted, effective mobile marketing strategies. Our team leverages the latest tools and trends to ensure your brand is always in your audience's pocket.
      </p>
      <ul className="list-disc pl-6 space-y-3 text-gray-800 mb-8">
        <li>SMS and push notification campaigns for instant engagement</li>
        <li>Mobile app marketing and App Store Optimization (ASO)</li>
        <li>Geo-targeted advertising to reach users in specific locations</li>
        <li>Mobile-friendly landing pages and conversion optimization</li>
        <li>Comprehensive analytics and conversion tracking</li>
      </ul>
      <div className="flex flex-col sm:flex-row gap-4 justify-center mt-8">
        <Link to="/" className="px-6 py-3 bg-brand-blue text-white rounded-lg shadow hover:bg-blue-700 transition font-semibold text-center">Back to Home</Link>
        <Link to="#contact" onClick={e => { e.preventDefault(); const section = document.getElementById('contact'); if (section) section.scrollIntoView({ behavior: 'smooth' }); }} className="px-6 py-3 bg-blue-100 text-brand-blue rounded-lg shadow hover:bg-blue-200 transition font-semibold text-center">Contact Us</Link>
      </div>
    </div>
  </section>
);

export default MobileMarketing; 